export function isRTEContentEmpty(content) {
    const trimmedContent = content.trim();
    if (trimmedContent === '' || /^(<[^>]*>(\s|&nbsp;)*<\/[^>]*>)*$/.test(trimmedContent)) {
        return true;
    }
    if (/^(<[^/>]+\/>)*$/.test(trimmedContent)) {
        return false;
    }
    return false;
}
